<script setup>

defineProps({
  rawErrors: {
    type: Array,
    required: false,
    default: () => [],
  },
  errors: {
    type: Array,
    required: false,
    default: () => [],
  },
})
</script>

<template>
  <div
    v-for="error in errors"
    :key="error"
    class="text-small text-danger mb-1"
  >
    {{ $t(error) }}
  </div>
  <div
    v-for="error in rawErrors"
    :key="error"
    class="text-small text-danger mb-1"
  >
    {{ error }}
  </div>
</template>
